<template>
  <VRow
    v-model="isConfirmDialogVisible"
    class="v-dialog-alert"
    :class="isConfirmDialogVisible ? 'active' : ''"
  >
    <div class="back-full-layer">
      <div class="alert-wrap bottom">
        <div class="tit-box">
          <div :class="titleClass">{{ title }}</div>
          <div class="confirm-message" style="white-space: pre-line" v-if="message">
            {{ message }}
          </div>
          <div :class="title2Class" style="white-space: pre-line">{{ title2 }}</div>
          <div class="warning-txt">{{ warning }}</div>
        </div>
        <div class="btn-box bottom">
          <button class="btn-nor bottom left cancel" @click="cancel">{{ cancelText }}</button>
          <button class="btn-nor" @click="closeConfirmDialog">{{ text }}</button>
        </div>
      </div>
    </div>
  </VRow>
</template>

<script setup>
import { ref, defineProps } from 'vue';
import { useBackLayer } from '@/composables/useAppBack';

const router = useRouter();
const props = defineProps({
  title: String,
  titleClass: String, // [추가]
  title2: String,
  title2Class: String, // [추가]
  message: String, // [추가]
  text: String,
  nextUrl: Function,
  closeOpt: String,
  warning: String,
  cancelText: { type: String, default: '취소' }, // [추가] 취소 버튼 텍스트 커스텀
  cancelUrl: Function, // [추가] 취소 시 실행할 함수
});

const emit = defineEmits(['cancel']);

const isConfirmDialogVisible = ref(false);

const closeConfirmDialog = () => {
  if (props.nextUrl) {
    props.nextUrl();
  }
  isConfirmDialogVisible.value = false;
};

const close = () => {
  isConfirmDialogVisible.value = false;
};

const openConfirmDialog = () => {
  isConfirmDialogVisible.value = true;
};

const cancel = () => {
  if (props.cancelUrl) {
    props.cancelUrl();
  }
  isConfirmDialogVisible.value = false;
  emit('cancel');
};

useBackLayer({
  id: 'common-confirm',
  isOpen: isConfirmDialogVisible,
  closeFromBack: cancel,
});

// 다이얼로그를 여는 메서드를 외부에서 호출할 수 있도록
defineExpose({ isConfirmDialogVisible, openConfirmDialog, close, dismissFromBack: cancel });
</script>
<style scoped>
.dialog-title {
  text-align: center; /* 가운데 정렬 */
}
.warning-txt {
  color: var(--Orange-500-Error, #ff453a);
  text-align: center;
  font-family: Pretendard;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  white-space: pre-line;
}

/* [추가] 타이틀 텍스트 스타일 */
.confirm-title-text {
  color: var(--Gray-800, #333);
  text-align: center;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
}

/* [추가] 날짜 텍스트 스타일 */
.confirm-date-text {
  font-family: Pretendard;
  font-size: 18px; /* 타이틀과 동일하게 */
  font-weight: 700;
  color: #333; /* #333으로 통일 */
  margin-top: -3px; /* 타이틀과 붙이기 */
}

.confirm-message {
  color: var(--Gray-800, #333);
  text-align: center;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 160% */
}

/* 주황색 하이라이트 텍스트 */
.confirm-highlight-orange {
  color: var(--orange-300-main, #eb4c10);
  text-align: center;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
</style>
